import { Injectable } from '@angular/core';
import { ApiBaseService } from '../api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchApiServiceService {

  constructor(private apiBaseService: ApiBaseService) { }

   searchAllData(searchText: string): Observable<any> {
    const customParams = {
      namePattern: searchText,
    }
    return this.apiBaseService.getWithParams(`/api/globalsearch`, customParams);
  }

}
